import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DynForm} from '../../domain/meta/dyn-form';
import {DynField} from '../../domain/meta/dyn-field';
import {DynSelectField} from '../../domain/meta/fields/select/dyn-select-field';
import {DynSubformField} from '../../domain/meta/fields/dyn-subform-field';
import {Modes} from 'app/forms/components/form-data/form-data.component';
import {ActivatedRoute, Router} from '@angular/router';
import { CookieConsent } from 'app/core/commons/cookie-consent.js/cookie-consent';

@Component({
    selector: 'app-form-data-fields',
    templateUrl: './form-data-fields.component.html',
    styleUrls: ['./form-data-fields.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormDataFieldsComponent {

    @Input()
    public form: DynForm;

    @Input()
    public formGroup: FormGroup;

    @Input()
    public mode: Modes = Modes.edit;

    public fields: Array<DynField> = [];

    public modes = Modes;
    private cookieConsent: CookieConsent;

    constructor(
        private router: Router,
        private route: ActivatedRoute,) {
        this.cookieConsent = new CookieConsent();
        this.cookieConsent.deleteCookie('subform-edit');
        this.cookieConsent.setCookie('subform-edit-parent',this.route.params['_value']['dataId'], 1);
    }

    @Input('form')
    set setForm(f: DynForm) {
        if (f) {
            this.form = f;
            this.fields = this.form.getFields();
        }
    }

    public getOptions(field: DynField) {
        return (field as DynSelectField).getOptions().getOptions();
    }

    public getSubform(field: DynField) {
        return (field as DynSubformField).getForm();
    }

    getField(field: DynField):DynField{
        var dato = field.getText(); 
        field.setText((dato.split('<CAMPO COMPLETABLE>')).join('{@}'));
        return field;
    }

    getControl(field:DynField){
            return this.formGroup.get(field.getName());
    }

    hasDivider(field):boolean{
        return field.divider;
    }

    editSubform() {
        this.cookieConsent.setCookie('subform-edit', 'true', 1);
        this.cookieConsent.setCookie('subform-edit-parent', this.form.getId().toString(), 1);
        this.router.navigate(['home', 'forms', this.form.getId()-1]);
    }

}



// WEBPACK FOOTER //
// ./src/app/forms/components/form-data-fields/form-data-fields.component.ts